<template lang="pug">
#yotpo-testimonials-custom-tab
  span(class='loading-text') Loading...
</template>
<script setup lang="ts">
useYotpo()
</script>

<style lang="stylus">
.loading-text
    font-size: theme('fontSize.xl')
</style>
